import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const BALL_COUNT = 5; // Number of balls

const GlowingBalls = () => {
  const [balls, setBalls] = useState([]);

  // Initialize balls with random positions and velocities
  useEffect(() => {
    const newBalls = Array.from({ length: BALL_COUNT }).map(() => ({
      id: Math.random(),
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      dx: (Math.random() - 0.5) * 4, // Random velocity X
      dy: (Math.random() - 0.5) * 4, // Random velocity Y
    }));
    setBalls(newBalls);
  }, []);

  // Update positions and handle bouncing
  useEffect(() => {
    const interval = setInterval(() => {
      setBalls((prevBalls) =>
        prevBalls.map((ball) => {
          let newX = ball.x + ball.dx;
          let newY = ball.y + ball.dy;
          let newDx = ball.dx;
          let newDy = ball.dy;

          // Collision with edges
          if (newX <= 0 || newX >= window.innerWidth - 100) newDx *= -1;
          if (newY <= 0 || newY >= window.innerHeight - 100) newDy *= -1;

          return { ...ball, x: newX, y: newY, dx: newDx, dy: newDy };
        })
      );
    }, 20); // Movement speed

    return () => clearInterval(interval);
  }, []);

  return (
    <Container>
      {balls.map((ball) => (
        <Ball
          key={ball.id}
          style={{ left: ball.x, top: ball.y }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </Container>
  );
};

export default GlowingBalls;

// Styled Components
const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

const Ball = styled(motion.div)`
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  filter: blur(40px);
  background-color: rgba(0, 150, 255, 0.4);
  box-shadow: 0 0 30px rgba(0, 150, 255, 0.7);
  transition: left 0.02s linear, top 0.02s linear;
  will-change: filter, transform;
`;
